import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Fornecedor de menu',
      options: {
        [null]: 'Selecionar fornecedor de menu',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Outro restaurante FoodAmigos',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'URL do Lieferando',
        placeholder: 'URL do restaurante no Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'URL do Wolt',
        placeholder: 'URL do restaurante no Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Link do restaurante no Deliveroo',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Abra o seu restaurante em Deliveroo e copie o link da barra de endereço.',
        error:
          'Introduza o link para a página do menu de um restaurante no Deliveroo. Tem este formato: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'URL do Uber Eats',
        placeholder: 'URL do restaurante no Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'Link GloriaFood',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Se utiliza a página de encomendas GloriaFood:',
            description: 'Insira o seu URL de encomendas foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Se a GloriaFood está incorporada no seu próprio site:',
            description: 'Insira o URL da página do seu site onde aparece o widget de encomendas.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Insira um link válido que comece por https://.',
        back_office_error:
          'Esta é uma ligação do back office GloriaFood, não a página onde os seus clientes fazem pedidos. Abra a página de pedidos do seu restaurante e cole essa ligação em vez disso.',
        wrong_platform_error:
          'Isto não parece ser um link da GloriaFood. Se utiliza a página de encomendas alojada pela GloriaFood, insira o seu URL de encomendas foodbooking.com. Se a GloriaFood está incorporada no seu próprio site, insira o URL da página onde aparece o seu widget de encomendas.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'URL do Thuisbezorgd',
        placeholder: 'URL do restaurante no Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'URL do Takeaway.com',
        placeholder: 'URL do restaurante no Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'URL do Pyszne.pl',
        placeholder: 'URL do restaurante no Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'URL do Bistro.sk',
        placeholder: 'URL do restaurante no Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'URL do Just Eat',
        placeholder: 'URL do restaurante no Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Link do restaurante no DoorDash',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Abra o seu restaurante em doordash.com e copie o link da barra de endereço.',
        error:
          'Introduza o link para uma página de restaurante no DoorDash. Começa por https://www.doordash.com/store/.',
        store_number_error:
          'Este link contém apenas o número da loja. Abra o restaurante em doordash.com e copie o link com o respetivo nome, por exemplo https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurante de onde copiar o menu',
        placeholder: 'Selecionar restaurante de onde copiar o menu',
      },
    },
  },
};
